'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export default class LoadingArea extends React.Component {
    static propTypes = {
        loading: PropTypes.bool,
        className: PropTypes.string,
        screenClassName: PropTypes.string,
        spinnerClassName: PropTypes.string
    };

    static defaultProps = {
        loading: false
    };

    render() {
        const className = classnames('loading-area', this.props.className);
        const screenClassName = classnames('loading-area__screen', this.props.screenClassName);
        const spinnerClassName = classnames('loading-area__spinner', this.props.spinnerClassName);

        return (
            <div className={className}>
                {this.props.loading && (
                    <div className={screenClassName}>
                        <div className={spinnerClassName}>
                            {flex.components.loader}
                        </div>
                    </div>
                )}
                {this.props.children}
            </div>
        );
    }
}
